import React from 'react';

const LinksBar: React.FC = () => {
  return (
    <div className="flex flex-col gap-4 text-xs text-slate-400 sm:flex-row sm:items-center sm:justify-between">
      <div className="space-y-1">
        <p className="font-medium text-slate-300">Nate Verlin</p>
        <p>Senior software developer focused on real-time systems for sports and live media.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <a
          href="mailto:nverlin@gmail.com"
          className="rounded-full border border-slate-700/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-200 hover:border-emerald-400 hover:text-emerald-200"
        >
          Email
        </a>
        <a
          href="https://www.linkedin.com/in/nate-verlin"
          target="_blank"
          rel="noreferrer"
          className="rounded-full border border-slate-700/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-200 hover:border-emerald-400 hover:text-emerald-200"
        >
          LinkedIn
        </a>
        <a
          href="/Nate Verlin CV.pdf"
          target="_blank"
          rel="noreferrer"
          className="rounded-full border border-slate-700/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-slate-200 hover:border-emerald-400 hover:text-emerald-200"
        >
          Resume
        </a>
      </div>
    </div>
  );
};

export default LinksBar;

